import * as CitySelection from './CitySelectionReducer';
import * as QueryParam from './QueryParam';
import * as Calendar from './CalendarReducer';
import * as SearchText from './SearchTextReducer';
const initialState = {
    citySelection: CitySelection.citySelectionState,
    queryParam: QueryParam.queryParamState,
    calendar: Calendar.calendarState,
    searchText: SearchText.searchTextState
};
// 请保证每一个字符串唯一，不然就会被覆盖
export const Actions = Object.assign(Object.assign(Object.assign(Object.assign({}, CitySelection.CitySelectionAction), QueryParam.QueryParamStateAction), Calendar.CalendarAction), SearchText.SearchTextAction);
export function reducer(state = initialState, action) {
    return {
        citySelection: CitySelection.CitySelectionReducer(state.citySelection, action),
        queryParam: QueryParam.queryParamReducer(state.queryParam, action),
        calendar: Calendar.CalendarReducer(state.calendar, action),
        searchText: SearchText.SearchTextReducer(state.searchText, action)
    };
}
